export const state = () => ({
  availablePaymentsMethodsLoading: false,
  availablePaymentsMethodsSuccess: [],
  availablePaymentsMethodsError: '',
})

export const getters = {
  availablePaymentsMethodsLoading(state) {
    return state.availablePaymentsMethodsLoading
  },
  availablePaymentsMethods(state) {
    return state.availablePaymentsMethodsSuccess
  },
  availablePaymentsMethodsError(state) {
    return state.availablePaymentsMethodsError
  },
}

export const mutations = {
  SET_AVAILABLE_PAYMENTS_METHODS_LOADING: (state, isLoading) => {
    state.availablePaymentsMethodsLoading = isLoading
  },
  SET_AVAILABLE_PAYMENTS_METHODS_SUCCESS: (state, success) => {
    state.availablePaymentsMethodsSuccess = success
  },
  SET_AVAILABLE_PAYMENTS_METHODS_ERROR: (state, error) => {
    state.availablePaymentsMethodsError = error
  },
}

export const actions = {
  async availablePayments({ commit }) {
    commit('SET_AVAILABLE_PAYMENTS_METHODS_LOADING', true)
    try {
      const availablePayments = await this.$axios.$get(
        '/api/policy/v1/pay/check'
      )
      commit('SET_AVAILABLE_PAYMENTS_METHODS_SUCCESS', availablePayments)
      commit('SET_AVAILABLE_PAYMENTS_METHODS_ERROR', '')
    } catch (error) {
      commit('SET_AVAILABLE_PAYMENTS_METHODS_SUCCESS', false)
      commit('SET_AVAILABLE_PAYMENTS_METHODS_ERROR', error || 'Error')
    }
    commit('SET_AVAILABLE_PAYMENTS_METHODS_LOADING', false)
  },
}
